// extracted by mini-css-extract-plugin
export default {"emptyStateBox":"EmptyStateBox_emptyStateBox__3I+HO","emptyStateText":"EmptyStateBox_emptyStateText__zKZU-","emptyStateImg":"EmptyStateBox_emptyStateImg__Bqh7P"};